import { LocatorLofiQueryResult } from 'src/app/locator/models/locator-lofi-report';
import { ProfilerLofiQueryResult } from 'src/app/profiler/model/profiler-lofi-report';

export function convertStatsDataToMarkDown(
  selectedQueryItem: ProfilerLofiQueryResult | LocatorLofiQueryResult | null
) {
  if (selectedQueryItem?.isGraph) {
    const graphData = selectedQueryItem.graphData;
    if (graphData && graphData.length > 0) {
      const header = '| Name | Value |\n| ----------- | ----------- |';
      const rows = graphData
        .map((data: any) => `| ${data.name} | ${data.value} |`)
        .join('\n');
      return `${header}\n${rows}`;
    }
  }

  if (selectedQueryItem?.isStats) {
    const statsData = selectedQueryItem.statsData;
    if (statsData && statsData.length > 0) {
      const header = '| Name | Value |\n| ----------- | ----------- |';
      const rows = statsData
        .map((data: any) => `| ${data.name} | ${data.value} |`)
        .join('\n');
      return `${header}\n${rows}`;
    }
  }

  return '';
}
